import AnonFeatureGuard from '@/components/guards/AnonFeatureGuard'
import StandaloneReferenceViewerCaseLawPage from '@/standalone-reference-viewer/caselaw/views/StandaloneReferenceViewerCaseLawPage'
import StandaloneReferenceViewerLrrPage from '@/standalone-reference-viewer/lrr/views/StandaloneReferenceViewerLrrPage'
import { kRouteSegments } from '@/routing/paths'
import type { RouteFactory } from '../types'

/**
 * Creates routes for standalone content viewers (reference viewer, caselaw, lrr).
 * These routes display referenced content outside of the chat context.
 * Global fallback only — matter-scoped versions live under MatterLayout in referenceViewer.tsx.
 * Kept to support legacy links generated before matter context was encoded in the URL path.
 */
export const createContentViewerRoutes: RouteFactory = () => [
  {
    path: `${kRouteSegments.referenceViewer}/caselaw/:idType?/:id`,
    element: (
      <AnonFeatureGuard showAuthOnGuard={true}>
        <StandaloneReferenceViewerCaseLawPage />
      </AnonFeatureGuard>
    ),
  },
  {
    path: `${kRouteSegments.referenceViewer}/lrr/:s3Path`,
    element: (
      <AnonFeatureGuard showAuthOnGuard={true}>
        <StandaloneReferenceViewerLrrPage />
      </AnonFeatureGuard>
    ),
  },
]
